(() => {
  const popup = document.querySelector('[data-exit-intent-popup]');
  if (!popup) return;

  const dialog = popup.querySelector('[data-exit-intent-dialog]');
  const form = popup.querySelector('[data-exit-intent-form]');
  const submitButton = popup.querySelector('[data-exit-intent-submit]');
  const errorBox = popup.querySelector('[data-exit-intent-error]');
  const successBox = popup.querySelector('[data-exit-intent-success]');
  const commentInput = popup.querySelector('#ExitIntentComment');
  const sessionKey = 'mixopro-exit-intent-seen';
  const pendingKey = 'mixopro-exit-survey-pending';
  const previewMode = false;
  const mobileOpenDelayMs = 20000;
  const desktopTopBoundary = 12;
  const mobileMinScrollY = 240;
  const mobileUpwardDeltaThreshold = 140;
  const isTouchDevice = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;

  if (previewMode) {
    form.hidden = false;
    successBox.hidden = true;
  }

  const i18n = {
    processing: dialog.dataset.processingText || 'Sending...',
    submit: dialog.dataset.submitText || 'Submit',
    errorChoice: dialog.dataset.errorChoice || 'Please select an option.',
    errorSave: dialog.dataset.errorSave || 'Could not save your answer.',
  };

  let canTrigger = false;
  let isOpen = false;
  let lastTouchScrollY = window.scrollY;

  if (!previewMode && sessionStorage.getItem(sessionKey) === 'true') return;

  window.setTimeout(() => {
    canTrigger = true;
  }, isTouchDevice ? mobileOpenDelayMs : 0);

  function setError(message) {
    if (!errorBox) return;
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  }

  function openPopup(source) {
    if ((!previewMode && !canTrigger) || isOpen || (!previewMode && sessionStorage.getItem(sessionKey) === 'true')) return;
    isOpen = true;
    if (!previewMode) sessionStorage.setItem(sessionKey, 'true');
    popup.hidden = false;
    popup.dataset.openedBy = source;
    requestAnimationFrame(() => popup.classList.add('is-visible'));
    document.body.classList.add('exit-intent-popup-open');
    if (typeof trapFocus === 'function') {
      trapFocus(dialog, popup.querySelector('[data-exit-intent-close]'));
    }
  }

  function closePopup() {
    if (!isOpen) return;
    isOpen = false;
    popup.classList.remove('is-visible');
    document.body.classList.remove('exit-intent-popup-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    window.setTimeout(() => {
      if (!isOpen) popup.hidden = true;
    }, 250);
  }

  function showSuccess() {
    form.hidden = true;
    successBox.hidden = false;
    dialog.classList.add('is-success');
    successBox.focus();
  }

  function savePending(payload) {
    const pending = JSON.parse(localStorage.getItem(pendingKey) || '[]');
    pending.push(payload);
    localStorage.setItem(pendingKey, JSON.stringify(pending.slice(-20)));
  }

  async function sendSurvey(payload) {
    const endpoint = window.MixoProCustomCheckout && window.MixoProCustomCheckout.exitSurveyEndpoint;
    if (!endpoint) {
      savePending(payload);
      return;
    }

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(i18n.errorSave);
  }

  document.addEventListener('mouseout', (event) => {
    if (isTouchDevice || !canTrigger || event.relatedTarget || event.clientY > desktopTopBoundary) return;
    openPopup('desktop-exit');
  });

  window.addEventListener('scroll', () => {
    if (!isTouchDevice || !canTrigger || isOpen) return;
    const currentY = window.scrollY;
    if (lastTouchScrollY > mobileMinScrollY && currentY - lastTouchScrollY < -mobileUpwardDeltaThreshold) {
      openPopup('mobile-upward-scroll');
    }
    lastTouchScrollY = currentY;
  }, { passive: true });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup();
  });
  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup();
  });
  popup.querySelectorAll('[data-exit-intent-close]').forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  if (previewMode) {
    openPopup('local-preview');
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (previewMode) return;

    const selected = form.querySelector('input[name="exit_reason"]:checked');
    if (!selected) {
      setError(i18n.errorChoice);
      return;
    }

    const payload = {
      source: 'exit_intent_survey',
      reason: selected.value,
      comment: commentInput.value.trim(),
      locale: document.documentElement.lang || 'en',
      page_url: window.location.href,
      page_title: document.title,
      trigger: popup.dataset.openedBy || 'unknown',
      submitted_at: new Date().toISOString(),
    };

    submitButton.disabled = true;
    submitButton.textContent = i18n.processing;
    setError('');

    try {
      await sendSurvey(payload);
      showSuccess();
    } catch (error) {
      setError(error.message || i18n.errorSave);
      submitButton.disabled = false;
      submitButton.textContent = i18n.submit;
    }
  });
})();
